<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.29724 16.6048H15.3832L8.34022 31.9371L1.29724 16.6048ZM8.34022 30.0395L14.1593 17.4026H2.54265L8.34022 30.0395Z" fill="#9013FE"/>
<path d="M19.0815 16.6263H29.603V17.4242H19.876V23.5054H28.3362V24.3033H19.876V30.8374H29.603V31.6352H19.0815V16.6263Z" fill="#9013FE"/>
<path d="M47.1726 31.6352H33.0866L40.1296 16.3029L47.1726 31.6352ZM34.332 30.8374H45.9272L40.1296 18.2005L34.332 30.8374Z" fill="#9013FE"/>
</svg>
